<template>
	<div class="classified-preview">
		<div class="pa-block">
			<h3 class="selector-title">Récapitulatif de l'annonce</h3>
			<div class="pa-block__inner pa-block__inner--flex">
				<div class="pa-block__main">
					<div class="pa-block__row pa-block__row--block">
						<p>
							<strong>Titre de l'annonce : </strong>
						</p>
						<div class="pa-summary">
							{{ classified.title }}
						</div>
						<!-- .pa-summary -->
					</div>
					<!-- .pa-block__row -->
					<div class="pa-block__row pa-block__row--block">
						<p>
							<strong>Texte de l'annonce :</strong>
						</p>
						<div class="pa-summary">
							<div v-html="classified.content"></div>
						</div>
						<!-- .pa-summary -->
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.profession"
					>
						<p>
							<strong>Profession concernée :</strong>
						</p>
						<div class="pa-summary">
							{{ professionTitle(classified.profession) }}
						</div>
						<!-- .pa-summary -->
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.cities"
					>
						<p>
							<strong>Villes :</strong>
						</p>
						<div class="pa-summary">
							{{ cities }}
						</div>
					</div>
					<!-- .pa-block__row -->
					<div class="pa-block__row pa-block__row--block" v-if="contracts">
						<p>
							<strong>Types de contract :</strong>
						</p>
						<div class="pa-summary">
							{{ contracts }}
						</div>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.profil_email"
					>
						<p>
							<strong>Email du contact (non visible sur l'annonce): </strong>
						</p>
						<div class="pa-summary">
							{{ classified.profil_email }}
						</div>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.mode === 'print_web' && classified.contact"
					>
						<p>
							<strong>
								Téléphone / email de contact à afficher sur l'annonce :
							</strong>
						</p>
						<div class="pa-summary">
							{{ classified.contact }}
						</div>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.available_dates"
					>
						<p>
							<strong>Disponibilité: </strong>
						</p>
						<div class="pa-summary">
							{{ classified.available_dates }}
						</div>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.partner_url"
					>
						<p>
							<strong>URL du partenaire</strong>
						</p>
						<div class="pa-summary">
							{{ classified.partner_url }}
						</div>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.logo"
					>
						<fieldset>
							<legend>Logo Annonceur</legend>
						</fieldset>
						<div>
							<Media :id="classified.logo" :editable="false" />
						</div>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row pa-block__row--block"
						v-if="classified.medias.length"
					>
						<fieldset>
							<legend>Photos</legend>
						</fieldset>
						<div v-if="allMedias.length">
							<Media
								:id="media_id"
								v-for="media_id in classified.medias"
								:key="media_id"
								:editable="false"
							/>
						</div>
					</div>
					<!-- .pa-block__row -->
				</div>
				<!-- .pa-block__main -->
				<div class="block-update">
					<div @click="goToStep2()">
						<span>Modifier l'annonce</span>
						<svg width="12" height="12">
							<use xlink:href="#icon-arrow" />
						</svg>
					</div>
				</div>
				<!-- .block-update -->
			</div>
			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .classified-preview -->
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import Media from "./Media.vue";
export default {
	name: "classified-resume",
	components: {
		Media,
	},
	mounted() {
		this.$scrollTo("#main"); //, 300, { easing: "ease" });
	},
	computed: {
		...mapState(["classified", "allMedias"]),
		...mapGetters(["getSettings"]),
		cities() {
			if (this.classified.cities_data)
				return this.classified.cities_data.map((c) => c.name).join(", ");
			return "";
		},
		contracts() {
			if (this.classified.contracts_data)
				return this.classified.contracts_data.map((c) => c.name).join(", ");
			return "";
		},
	},
	methods: {
		// ...mapMutations(["setStep"]),
		goToStep1() {
			this.setStep("1");
		},
		goToStep2() {
			this.setStep("2");
		},
		categoryName(category_id) {
			return this.$store.state.categories.find(
				(cat) => cat.term_id == category_id
			);
		},
	},
};
</script>
